import Modal from "../../ui-components/Modal";
import useCountryAxiosInstance from "../../hooks/useCountryAxiosInstance";
import Button from "../../ui-components/Button";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";

function WorksiteAbandonModal({
  closeModal,
  selectedWorksite,
  toggleAbandonWorksiteDialog,
  countryCode
}) {
  const apiRequest = useCountryAxiosInstance();
  const { push } = useHistory();

  const abandonWorksite = async () => {
    let cancel = false;
    try {
      const ret = await Promise.all([
        apiRequest.post(`/worksites/${selectedWorksite.id}/abandon`),
      ]);
      if (ret) {
        push("/" + countryCode + "/worksites");
        if (!cancel) {
          toggleAbandonWorksiteDialog();
        }
      }
    } catch (error) {
      if (!cancel) {
        console.log("errore", error);
      }
    }
  };

  return (
    <Modal onExit={closeModal}>
      <div className="flex w-full flex-col h-full items-center justify-center">
        <label className="ml-2 block text-m text-black-500">
          <FormattedMessage id="confirm_worksite_abandon" />
        </label>
        <div className="w-full mt-4 flex justify-center">
          <Button variant="contained" color="primary" onClick={abandonWorksite}>
            <FormattedMessage id="abandon" />
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default WorksiteAbandonModal;
